import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  CircularProgress,
  Typography
} from '@material-ui/core';
import { UserType } from '../validation';
import userSlice from '../collections/user';
import errorCodes from '../constants/errorCodes';
import i18n from '../i18n';
import isAuthEnabled from '../helpers/authHelpers';
import { fetchMe } from '../helpers/externalRequests';

class WithMyEmployeeData extends Component {
  constructor(props) {
    super(props);

    const { user } = props;
    this.state = {
      loaded: user.myEmployeeId || false,
      errorCode: null
    };
  }

  componentDidMount = () => {
    const { loaded } = this.state;
    if (!loaded || !isAuthEnabled()) {
      this.getMyEmployeeId();
    }
  };

  getMyEmployeeId = () => {
    const { 
      logged, 
      onLoaded, 
      user: { 
        email 
      } 
    } = this.props;
    return fetchMe(email, isAuthEnabled)
      .then((res) => {
        logged({ myEmployeeId: res.data.id });
        this.setState({ loaded: true })
        if (onLoaded) {
          onLoaded()
        }
      }).catch((e) => {
        if (e.response && e.response.status === 404) {
          return this.setState({ errorCode: 'noEmployeeProfile' })
        }
        if (e.response && errorCodes[e.response.status]) {
          this.setState({ errorCode: errorCodes[e.response.status] })
        }
        console.error(e);
        return null
      });
  }

  render() {
    const { children } = this.props;
    const { loaded, errorCode } = this.state;

    if (errorCode) {
      return (
        <div>
          {i18n.t(`loginError:${errorCode}`)}
        </div>
      );
    }
    if (!loaded) {
      return (
        <>
          <CircularProgress color="secondary" />
          <Typography variant="body1">{i18n.t('loading')}</Typography>
        </>
      );
    }
    return children;
  }
}

const mapDispatchToProps = { logged: userSlice.actions.logged };

const mapStateToProps = (state) => ({
  user: state.user,
});

WithMyEmployeeData.propTypes = {
  children: PropTypes.node,
  logged: PropTypes.func.isRequired,
  user: UserType.isRequired,
  onLoaded: PropTypes.func
};

WithMyEmployeeData.defaultProps = {
  children: null,
  onLoaded: null
};

export { WithMyEmployeeData as WithMyEmployeeDataNoConnect }
export default connect(mapStateToProps, mapDispatchToProps)(WithMyEmployeeData);